import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import StudentOverview from "../components/Student/StudentOverview/StudentOverview";
import StudentCourses from "../components/Student/StudentCourses/StudentCourses";
import StudentCourseDetail from "../components/Student/StudentCourseDetail/StudentCourseDetail";
import StudentCourseVideoSection from "../components/Student/StudentCourseVideoSection/StudentCourseVideoSection";
import StudentAssignment from "../components/Student/StudentAssignment/StudentAssignment";
import StudentAssignmentDetails from "../components/Student/StudentAssignmentDetails/StudentAssignmentDetails";
import StudentAssignmentResult from "../components/Student/StudentAssignmentResult/StudentAssignmentResult";
import StudentFinalAssignmentResult from "../components/Student/StudentFinalAssignmentResult/StudentFinalAssignmentResult";
import StudentCertificate from "../components/Student/StudentCertificate/StudentCertificate";
import StudentInternship from "../components/Student/StudentInternship/StudentInternship";
import StudentChats from "../components/Student/StudentChats/StudentChats";
import StudentFeedback from "../components/Student/StudentFeedback/StudentFeedback";
import StudentProfile from "../components/Student/StudentProfile/StudentProfile";
import StudentPurchase from "../components/Student/StudentPurchase/StudentPurchase";

import StudentRouteGuard from "../components/ProtectedRoute/StudentRouteGuard";
import StudentNotFound from "../components/Student/StudentNotFound/StudentNotFound";

const StudentRoutes = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="overview" replace />} />

      <Route
        path="overview"
        element={
          <StudentRouteGuard accessField="overview_unlocked">
            <StudentOverview />
          </StudentRouteGuard>
        }
      />
      <Route path="courses" element={<StudentCourses />} />
      <Route path="course-detail/:courseId" element={<StudentCourseDetail />} />
      <Route
        path="course-videos/:courseId"
        element={<StudentCourseVideoSection />}
      />
      <Route
        path="assignments"
        element={
          <StudentRouteGuard accessField="assignment_unlocked">
            <StudentAssignment />
          </StudentRouteGuard>
        }
      />
      <Route
        path="assignment-detail/:assignmentId"
        element={
          <StudentRouteGuard accessField="assignment_unlocked">
            <StudentAssignmentDetails />
          </StudentRouteGuard>
        }
      />
      <Route
        path="assignment-result/:assignmentId"
        element={
          <StudentRouteGuard accessField="assignment_unlocked">
            <StudentAssignmentResult />
          </StudentRouteGuard>
        }
      />
      <Route
        path="final-assignment-result/:finalAssignmentId"
        element={
          <StudentRouteGuard accessField="assignment_unlocked">
            <StudentFinalAssignmentResult />
          </StudentRouteGuard>
        }
      />
      <Route
        path="certificate"
        element={
          <StudentRouteGuard accessField="certificate_unlocked">
            <StudentCertificate />
          </StudentRouteGuard>
        }
      />
      <Route
        path="internship"
        element={
          <StudentRouteGuard accessField="internship_unlocked">
            <StudentInternship />{" "}
          </StudentRouteGuard>
        }
      />
      <Route
        path="chats"
        element={
          <StudentRouteGuard accessField="chat_unlocked">
            <StudentChats />
          </StudentRouteGuard>
        }
      />
      <Route path="feedback/:courseId" element={<StudentFeedback />} />
      <Route path="profile" element={<StudentProfile />} />
      <Route path="purchase" element={<StudentPurchase />} />

      <Route path="not-found" element={<StudentNotFound />} />
      {/* Catch all wrong student routes */}
      <Route path="*" element={<StudentNotFound />} />
    </Routes>
  );
};

export default StudentRoutes;
